/* src/components/loading-spinner/loading-spinner.component.scss */
:host {
  display: inline-block;
  vertical-align: top;
  line-height: 30px;
}
:host svg {
  display: inline-block;
  vertical-align: top;
  width: 30px;
  height: 30px;
}
:host svg circle {
  stroke: currentColor;
}
:host.loading-spinner-small {
  line-height: 20px;
}
:host.loading-spinner-small svg {
  width: 20px;
  height: 20px;
}
.loading-message {
  display: inline-block;
  vertical-align: top;
  margin: 0 0 0 10px;
  line-height: inherit;
}
.loading-message:empty {
  display: none;
}
/*# sourceMappingURL=loading-spinner.component-PBV5BPMO.css.map */
